<template>
<div v-clickoutside="changeShow"  @mouseleave="changeShow" style="width:100%" class="cont-right-one select-box" id="ftpContRight" :class="selectBoxClass" @click="selectShowFunction" @click.stop="selectShow=!selectShow" ref="sel">
    <div>
        <span>{{currentValue}}</span>
        <div class="icon-util" :class="dropDownName" style="float: right;"></div>
    </div>
    <div class="select-value" style="maxHeight: 170Px !important;" v-show="selectShow&&selectOption.length" id="selectValue" ref="selectValueWidth">
         <el-scrollbar style="height:100%;">
        <div class='select-value-option' :key=index @click="changSelectValue($event,index)" v-for="(item,index) in selectOption">
            {{item.name}}
            <div v-if="item.icon==true" class="icon-util vip select-vip-position"></div>
        </div>
         </el-scrollbar>
    </div>
</div>
</template>

<script>
// 该组件仅用于双重验证
export default {
    data: function () {
        return {
            selectShow: false,
            selectBoxClass: '',
            dropDownName: 'drop-down',
            currentValue: this.placeholder,
            selectLength: this.selectOption,
            maxValue: 0,
            source:null
        }
    },
    watch: {
        currentValue(newName, oldName) {
            this.$emit('changeOption', newName);
        }
    },
    props: {
        selectOption: {
            type: Array,
            default () {
                return []
            }
        },
        placeholder: {
            type: String
        },
        widthVal: {
            type: null
        }
    },
    mounted() {
  
    },
    methods: {
        selectShowFunction() { //选中选项时控制下拉框的
            let lengthItem = [];
            if (this.selectShow) {
                this.selectBoxClass = '';
                this.dropDownName = 'drop-down';
            } else {
                this.selectBoxClass = 'select-box-click';
                this.dropDownName = 'drop-down-up';
            }
            let mainLength = this.$refs.sel; //选中选项的长度
            let selectLength = this.$refs.selectValueWidth; //下边未选中选项的长度
            selectLength.style.width = mainLength.clientWidth + 'Px';
            selectLength.style.height = (this.selectLength.length) * 34 + 'Px';
        },
        sortNumber(a, b) {
            return b - a
        },
        changSelectValue(event, index) {
            this.currentValue = event.currentTarget.innerText;
            this.selectShowFunction();
            this.$emit('deleteSelectOption', index);
        },
        changeShow() {
            this.selectShow = false;
            this.selectBoxClass = '';
            this.dropDownName = 'drop-down';
        }
    }
}
</script>

<style scoped>
/*设置下拉框样式*/
.select-box {
    height: 34px;
    /*no*/
    border: 1px solid #E0EAF9;
    /*no*/
    outline: none;
    margin-top: 10px;
    /*no*/
    box-sizing: border-box;
    background-color: transparent;
    padding-left: 10px;
    /*no*/
    line-height: 34px;
    /*no*/
    font-size: 14px;
    /*no*/
    margin-left: 10px;
    /*no*/
    background: #FFF;
}

.select-box-click {
    border: 1px solid #8A96E3;
    /*no*/
}

.select-value {
    position: absolute;
    z-index: 300;
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #8A96E3;
    /*no*/
    border-top: none;
    background: #FFF;
    left: -1px;
    /*no*/
    top: 33px;
    /*no*/
}

.select-value-option {
    width: 100%;
    height: 34px;
    /*no*/
    line-height: 34px;
    /*no*/
    padding: 0px 10px 0px 10px;
    /*no*/
    box-sizing: border-box;
    white-space: nowrap;
    cursor: pointer;

}

.select-value-option:hover {
    background-color: #EBF3FE;
   
}

.select-vip-position {
    position: relative;
    top: 26%;
    float: right;
}

.cont-right-one {
    min-width: 200px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    margin-left: 10px;
    /*no*/
    float: left;
    position: relative;
}

#ftpContRight {
    white-space: nowrap;
    max-width: 600px !important;
    /*no*/
}

#selectValue {
    max-width: 600px !important;
    /*no*/
}
.item-readOnly{
     pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/select/set_cloud_select.vue